import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-not-found-page',
  standalone: true,
  imports: [RouterLink],
  template: `
    <section class="page">
      <h1>Page introuvable</h1>
      <p>Cette route n existe pas.</p>
      <p><a routerLink="/tournaments">Retour aux tournois</a></p>
    </section>
  `,
  styles: `
    .page { padding: 1rem; }
    h1 { margin: 0 0 0.6rem; font-size: 1.4rem; }
    p { margin: 0.3rem 0; color: #52606d; }
    a { color: #1d4c9a; text-decoration: none; }
  `
})
export class NotFoundPageComponent {}
